<template>
  <div id="user_change_logs_tab">
    <LoadingContainer v-if="loading" />
    <div v-else>
      <EmptyState v-if="!logs.length">
        Nenhuma alteração registrada ainda.
      </EmptyState>

      <div v-else>
        <div class="table-responsive">
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th>Data</th>
                <th>Campo</th>
                <th>Valor Anterior</th>
                <th>Valor Novo</th>
                <th>Alterado por</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="log in logs" :key="log.id">
                <td>
                  <small>{{ formatDate(log.created_at) }}</small>
                </td>
                <td>
                  <span class="badge bg-primary">{{
                    formatFieldName(log.field)
                  }}</span>
                </td>
                <td>
                  <span class="text-muted small">{{
                    log.old_value || "-"
                  }}</span>
                </td>
                <td>
                  <span class="fw-bold small">{{ log.new_value || "-" }}</span>
                </td>
                <td>
                  <small v-if="log.changed_by">
                    {{ log.changed_by.name }}
                    <span class="text-muted">({{ log.changed_by.id }})</span>
                    <br />
                    <span class="text-muted">{{ log.changed_by.email }}</span>
                  </small>
                  <small v-else class="text-muted">-</small>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginação -->
        <div class="row mt-4" v-if="pagination.last_page > 1">
          <div class="col-12 text-center">
            <p class="text-muted small mb-3">
              Mostrando {{ pagination.from }} a {{ pagination.to }} de
              {{ pagination.total }} registros
            </p>
            <nav>
              <ul class="pagination pagination-sm justify-content-center">
                <li
                  class="page-item"
                  :class="{ disabled: !pagination.prev_page_url }"
                >
                  <button
                    class="page-link"
                    @click="loadPage(pagination.current_page - 1)"
                    :disabled="!pagination.prev_page_url"
                  >
                    Anterior
                  </button>
                </li>
                <li
                  v-for="page in visiblePages"
                  :key="page"
                  class="page-item"
                  :class="{ active: page === pagination.current_page }"
                >
                  <button class="page-link" @click="loadPage(page)">
                    {{ page }}
                  </button>
                </li>
                <li
                  class="page-item"
                  :class="{ disabled: !pagination.next_page_url }"
                >
                  <button
                    class="page-link"
                    @click="loadPage(pagination.current_page + 1)"
                    :disabled="!pagination.next_page_url"
                  >
                    Próxima
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserChangeLogsTab",
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      logs: [],
      pagination: {
        current_page: 1,
        last_page: 1,
        from: 0,
        to: 0,
        total: 0,
        prev_page_url: null,
        next_page_url: null,
      },
    };
  },
  computed: {
    visiblePages() {
      const pages = [];
      const current = this.pagination.current_page;
      const last = this.pagination.last_page;

      // Mostra até 5 páginas
      let start = Math.max(1, current - 2);
      let end = Math.min(last, current + 2);

      // Ajusta se estiver no início ou fim
      if (current <= 3) {
        end = Math.min(5, last);
      }
      if (current >= last - 2) {
        start = Math.max(1, last - 4);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },
  },
  mounted() {
    this.loadLogs();
  },
  methods: {
    async loadLogs(page = 1) {
      this.loading = true;
      try {
        const res = await this.$userService.listUserChangeLogs(this.userId, {
          page,
        });
        this.logs = res.data || [];
        this.pagination = {
          current_page: res.current_page || 1,
          last_page: res.last_page || 1,
          from: res.from || 0,
          to: res.to || 0,
          total: res.total || 0,
          prev_page_url: res.prev_page_url,
          next_page_url: res.next_page_url,
        };
      } catch (e) {
        console.error("Erro ao carregar histórico de mudanças:", e);
      } finally {
        this.loading = false;
      }
    },

    loadPage(page) {
      if (page >= 1 && page <= this.pagination.last_page) {
        this.loadLogs(page);
      }
    },

    formatDate(dateString) {
      return this.$moment(dateString).format("DD/MM/YYYY HH:mm");
    },

    formatFieldName(field) {
      const fieldNames = {
        email: "E-mail",
        name: "Nome",
        phone: "Telefone",
        document_number: "CPF",
        birth_date: "Data de Nascimento",
        gender: "Gênero",
        crp: "CRP",
        appointment_price: "Valor da Consulta",
        first_appointment_price: "Valor Consulta Inicial",
        imediate: "Imediata",
        online: "Online",
        block_agenda: "Bloquear Agenda",
        active: "Ativo",
        call_provider: "Provedor de Chamada",
        business_type: "Tipo de Conta",
      };

      return fieldNames[field] || field;
    },
  },
};
</script>

<style scoped>
.table {
  font-size: 0.875rem;
}

.badge {
  font-weight: 500;
}
</style>
